/* AWA size calculator - calculation engine (CLAUDE DRAFT, v78).
   Same base method as v77. Fixes: split >10 kW incl. occupants, real multi-head
   indoor/outdoor sizes, occupants on multi-room jobs, state climate factor,
   ducted breakdown shown step by step. Pure functions, no DOM. */
(function (root) {
  var BASE_KW_PER_M2 = 0.165;
  var OCCUPANT_KW = 0.12;
  var SPLIT_SIZES = [1.5, 2.0, 2.5, 3.5, 5.0, 6.0, 7.1, 8.0, 8.5, 9.0, 9.5, 10.0];
  var MULTI_INDOOR_SIZES = [2.0, 2.5, 3.5, 5.0, 6.0, 7.1];
  var MULTI_OUTDOOR_SIZES = [4.0, 5.0, 6.0, 7.1, 8.0, 9.0, 10.0, 12.0, 14.0];
  var DUCTED_SIZES = [8.5, 10, 12, 14, 16, 18, 20];
  var DUCTED_DIVERSITY = 0.90;
  var DUCTED_CALIBRATION = 0.70;
  var HEATING_STATES = ['TAS', 'VIC', 'ACT'];

  function nextUp(load, sizes) {
    for (var i = 0; i < sizes.length; i++) if (sizes[i] >= load - 1e-9) return sizes[i];
    return null;
  }
  function nextDown(value, sizes) {
    var out = null;
    for (var i = 0; i < sizes.length; i++) if (sizes[i] <= value + 1e-9) out = sizes[i];
    return out;
  }
  function prevSize(size, sizes) {
    var idx = sizes.indexOf(size);
    return idx > 0 ? sizes[idx - 1] : 0;
  }
  function parseClimate(text) {
    var map = {};
    String(text || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      var key = (bits[0] || '').trim().toUpperCase();
      var val = parseFloat(bits[1]);
      if (key && isFinite(val) && val > 0.5 && val < 2) map[key] = val;
    });
    return map;
  }

  function compute(input) {
    var system = input.system || 'single';
    var climateMap = input.climate || {};
    var climate = climateMap[input.state] || 1;
    var occupants = Math.max(1, Math.floor(Number(input.occupants) || 1));
    var extraOcc = Math.max(0, occupants - 2) * OCCUPANT_KW;
    var shared = (Number(input.ceiling) || 1) * (Number(input.insulation) || 1) *
      (Number(input.construction) || 1) * climate;

    var rooms = (input.rooms || []).map(function (r, i) {
      var area = Number(r.length) * Number(r.width);
      var factor = shared * (Number(r.type) || 1) * (Number(r.windows) || 1) *
        (Number(r.walls) || 1) * (r.top ? 1.08 : 1);
      return { index: i, name: r.name || ('Room ' + (i + 1)), area: area,
        baseLoad: area * BASE_KW_PER_M2, load: area * BASE_KW_PER_M2 * factor, occupantLoad: 0 };
    });

    var errors = [];
    rooms.forEach(function (r) {
      if (!(r.area > 0)) errors.push(r.index);
    });
    if (errors.length) return { error: 'room', roomIndex: errors[0] };

    var totalArea = rooms.reduce(function (s, r) { return s + r.area; }, 0);
    var roomSum = rooms.reduce(function (s, r) { return s + r.load; }, 0);

    // Extra occupants: added to the largest room (where people gather), so every
    // system type and every displayed figure includes them consistently.
    if (extraOcc > 0 && system !== 'ducted' && rooms.length) {
      var biggest = rooms.reduce(function (a, b) { return b.area > a.area ? b : a; });
      biggest.load += extraOcc;
      biggest.occupantLoad = extraOcc;
    }

    var res = { system: system, state: input.state || '', climate: climate, occupants: occupants,
      extraOccupantLoad: extraOcc, totalArea: totalArea, rooms: rooms,
      heatingNote: HEATING_STATES.indexOf(input.state) !== -1, quoteRequired: false };

    if (system === 'ducted') {
      var withOcc = roomSum + extraOcc;
      var diversity = rooms.length > 1 ? DUCTED_DIVERSITY : 1;
      var adjusted = withOcc * diversity * DUCTED_CALIBRATION;
      var size = nextUp(adjusted, DUCTED_SIZES);
      res.roomLoadTotal = withOcc;
      res.diversity = diversity;
      res.calibration = DUCTED_CALIBRATION;
      res.load = adjusted;
      res.overLimit = adjusted > 20 || size === null;
      res.size = res.overLimit ? null : size;
      res.lowerSize = res.overLimit ? null : prevSize(size, DUCTED_SIZES);
      res.quoteRequired = res.overLimit;
      return res;
    }

    if (system === 'multi') {
      var roomTooBig = false;
      rooms.forEach(function (r) {
        r.unit = nextUp(r.load, MULTI_INDOOR_SIZES);
        if (r.unit === null) roomTooBig = true;
      });
      var indoorTotal = rooms.reduce(function (s, r) { return s + (r.unit || 0); }, 0);
      var upper = roomTooBig ? null : nextUp(indoorTotal, MULTI_OUTDOOR_SIZES);
      res.load = rooms.reduce(function (s, r) { return s + r.load; }, 0);
      res.indoorTotal = indoorTotal;
      res.roomTooBig = roomTooBig;
      res.overLimit = roomTooBig || upper === null;
      res.outdoorUpper = res.overLimit ? null : upper;
      res.outdoorLower = res.overLimit ? null : (nextDown(Math.max(4.0, upper - 2), MULTI_OUTDOOR_SIZES) || upper);
      res.size = res.outdoorUpper;
      res.quoteRequired = res.overLimit;
      return res;
    }

    // Split systems: each room is its own unit; one room = one system.
    rooms.forEach(function (r) {
      r.unit = r.load > 10 ? null : nextUp(r.load, SPLIT_SIZES);
      r.lowerSize = r.unit ? prevSize(r.unit, SPLIT_SIZES) : null;
    });
    res.load = rooms.reduce(function (s, r) { return s + r.load; }, 0);
    res.overLimit = rooms.some(function (r) { return r.unit === null; });
    res.separate = rooms.length > 1;
    res.size = !res.separate && !res.overLimit ? rooms[0].unit : null;
    res.lowerSize = !res.separate && !res.overLimit ? rooms[0].lowerSize : null;
    res.quoteRequired = res.overLimit;
    return res;
  }

  var api = { compute: compute, parseClimate: parseClimate, nextUp: nextUp,
    SPLIT_SIZES: SPLIT_SIZES, MULTI_INDOOR_SIZES: MULTI_INDOOR_SIZES,
    MULTI_OUTDOOR_SIZES: MULTI_OUTDOOR_SIZES, DUCTED_SIZES: DUCTED_SIZES,
    BASE_KW_PER_M2: BASE_KW_PER_M2 };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.AWACalcCore = api;
})(typeof window !== 'undefined' ? window : this);